// Redux slice quản lý phòng ban
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";
import { toast } from "react-toastify";

export const fetchNhomHangHoa = createAsyncThunk("nhomHangHoa/fetchNhomHangHoa", async (params = {}, { rejectWithValue }) => {
  try {
    const res = await api.get("/product.category", {
      params: {
        size: params.pageSize || 1000,
        order: "id desc",
        page: params.page || 1,
        search: params.search || undefined,
        categ_type: "item",
      },
    });
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const addNhomHangHoa = createAsyncThunk("nhomHangHoa/addNhomHangHoa", async (payload, { rejectWithValue }) => {
  try {
    const res = await api.post("/product.category", payload);
    toast.success("Thêm phòng ban thành công!");
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const updateNhomHangHoa = createAsyncThunk("nhomHangHoa/updateNhomHangHoa", async (payload, { rejectWithValue }) => {
  try {
    const res = await api.put(`/product.category/${payload.id}`, payload);
    toast.success("Cập nhật phòng ban thành công!");
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const deleteNhomHangHoa = createAsyncThunk("nhomHangHoa/deleteNhomHangHoa", async (id, { rejectWithValue }) => {
  try {
    await api.delete(`/product.category/${id}`);
    toast.success("Xóa phòng ban thành công!");
    return id;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const fetchLoaiHangHoa = createAsyncThunk("nhomHangHoa/fetchLoaiHangHoa", async (params = {}, { rejectWithValue }) => {
  try {
    const res = await api.get("/medeco.service.group", {
      params: {
        size: params.size || 100,
        order: "id desc",
        page: params.page || 1,
        type: "item",
      },
    });
    return res.data?.content || [];
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

const nhomHangHoaSlice = createSlice({
  name: "nhomHangHoa",
  initialState: {
    items: { content: [], totalElements: 0 },
    loaiHangHoas: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNhomHangHoa.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNhomHangHoa.fulfilled, (state, action) => {
        state.items = action.payload || [];
        state.loading = false;
      })
      .addCase(fetchNhomHangHoa.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addNhomHangHoa.fulfilled, (state, action) => {
        state.items.content.push(action.payload);
        state.items.totalElements += 1;
      })
      .addCase(updateNhomHangHoa.fulfilled, (state, action) => {
        const idx = state.items.content.findIndex((d) => d.id === action.payload.id);
        if (idx > -1) state.items.content[idx] = { ...state.items.content[idx], ...action.payload };
      })
      .addCase(deleteNhomHangHoa.fulfilled, (state, action) => {
        state.items.content = state.items.content?.filter((d) => d.id !== action.payload);
        state.items.totalElements -= 1;
      })
      .addCase(fetchLoaiHangHoa.fulfilled, (state, action) => {
        state.loaiHangHoas = action.payload || [];
      });
  },
});

export default nhomHangHoaSlice.reducer;
